import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Form} from "react-bootstrap";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Loading from "../../component/Loading/Loading";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import Objects from "../../utils/Objects";
import NotFound from "../../component/NotFound/NotFound";
import Notify from "../../services/Notify";
import CheckpointService from "../CheckpointService";
import ReadpointCustomSelect from "../../readpoint/component/ReadpointCustomSelect";
import FormButtons from "../../component/Form/FormButtons";

class CheckpointReadpointSelect extends React.Component {

  service = new CheckpointService();

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      readpointsIds: []
    };
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (Objects.isNullOrUndefined(id)) {
      return;
    }
    this.setState({loading: true});
    this.service.findById(id).then(
        data => this.setState(
            {
              loading: false,
              checkpoint: data,
              isIntegrated: data.isIntegrated,
              readpointsIds: data.readpoints ? data.readpoints.map(({id}) => id) : []
            }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submit(e) {
    e.preventDefault()
    const {history} = this.props;
    const {checkpoint, readpointsIds} = this.state;

    this.service.saveReadpoints(checkpoint.id, readpointsIds).then(
        () => Notify.success('Atualização efetuada') && history.goBack(),
        error => {
          Notify.error('Problema ao associar', error);
        }
    )
    ;
  }

  render() {
    const {history} = this.props;
    const {loading, checkpoint, readpointsIds} = this.state;

    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de Ponto de Controle" to="/list/checkpoints"/>,
      <BreadcrumbItem key={3} title="Pontos de leitura do ponto de controle" active={true}/>];

    if (loading) {
      return <Loading/>;
    }

    if (Objects.isNullOrUndefined(checkpoint)) {
      return <NotFound/>;
    }
    
    return (
        <Page title={`Pontos de leitura do "${checkpoint.friendlyName}"`} breadcrumbs={breadcrumbs}>
          <Box info>
            <Form onSubmit={this.submit}>
              <Alert>
                Selecione os pontos de letiuras que deveram executar este ponto de controle!
              </Alert>
              <ReadpointCustomSelect checkpoint={checkpoint} readpointsIds={readpointsIds}
                                     setValue={readpointsIds => this.setState({ readpointsIds })} history={history}/>
              <FormButtons history={this.props.history} style={{marginTop: 10}}/>
            </Form>
          </Box>
        </Page>);
  }
  ;
}

CheckpointReadpointSelect.defaultProps = {
  checkpoint: null,
};

CheckpointReadpointSelect.propTypes = {
  checkpoint: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default CheckpointReadpointSelect;



// WEBPACK FOOTER //
// ./src/checkpoint/component/CheckpointReadpointSelect.js